import { useState } from "react";
import { AlertTriangle, X, Trash2 } from "lucide-react";

const DeleteConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Подтверждение удаления",
  itemName = "",
  itemType = "элемент",
  warningText = "Это действие нельзя отменить.",
}) => {
  const [isDeleting, setIsDeleting] = useState(false);

  if (!isOpen) return null;

  const handleConfirm = async () => {
    setIsDeleting(true);
    try {
      await onConfirm();
      onClose();
    } catch (error) {
      console.error("Delete error:", error);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
      <div className="bg-[#0A0A0A] rounded-xl border border-[#1F1F1F] w-full max-w-md">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-[#1F1F1F]">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-[#F87171]/15 rounded-lg">
              <AlertTriangle className="text-[#F87171]" size={20} />
            </div>
            <h3 className="text-white font-semibold">{title}</h3>
          </div>
          <button
            onClick={onClose}
            className="text-[#A1A1AA] hover:text-white transition-colors"
            data-testid="delete-modal-close-btn"
          >
            <X size={20} />
          </button>
        </div>

        {/* Content */}
        <div className="p-5 space-y-3">
          <p className="text-white text-base">
            Вы действительно хотите удалить {itemType}
            {itemName && (
              <>
                {" "}
                <span className="font-mono text-[#EDEDED]">{itemName}</span>
              </>
            )}
            ?
          </p>
          <p className="text-[#A1A1AA] text-sm">{warningText}</p>
        </div>

        {/* Footer */}
        <div className="flex gap-3 p-4 border-t border-[#1F1F1F]">
          <button
            onClick={onClose}
            disabled={isDeleting}
            className="flex-1 bg-[#1F1F1F] text-white py-3 rounded-lg hover:bg-[#3E3E3E] transition-colors disabled:opacity-50"
            data-testid="delete-modal-cancel-btn"
          >
            Нет
          </button>
          <button
            onClick={handleConfirm}
            disabled={isDeleting}
            className="flex-1 bg-[#F87171] text-white py-3 rounded-lg hover:bg-[#C53030] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            data-testid="delete-modal-confirm-btn"
          >
            {isDeleting ? (
              <>
                <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                Удаление...
              </>
            ) : (
              <>
                <Trash2 size={16} />
                Да, удалить
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
